import StatisticsRow from '../StatisticsRow';
import StatisticsNumber from '../StatisticsNumber';
import StatisticsLabel from '../StatisticsLabel';

interface RowLabelAndNumbersProps {
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Optional CSS classes to apply to the number columns. */
  numberColumnClassName?: string;
  /** Label describing the statistic, e.g. "Games Played", "% Victory". */
  label: string;
  /** Number for the home team. */
  homeNumber: number;
  /** Number for the away team. */
  awayNumber: number;
}

export default function RowLabelAndNumbers({
  className = '',
  numberColumnClassName = '',
  label,
  homeNumber,
  awayNumber,
}: RowLabelAndNumbersProps) {
  return (
    <StatisticsRow className={className}>
      <StatisticsNumber className={numberColumnClassName}>{homeNumber}</StatisticsNumber>
      <StatisticsLabel>{label}</StatisticsLabel>
      <StatisticsNumber className={`[direction:rtl] ${numberColumnClassName}`}>
        {awayNumber}
      </StatisticsNumber>
    </StatisticsRow>
  );
}
